import { render } from "./courseclassify.vue?vue&type=template&id=61002e9a&scoped=true&ts=true"
import script from "./courseclassify.vue?vue&type=script&lang=ts"
export * from "./courseclassify.vue?vue&type=script&lang=ts"

import "./courseclassify.vue?vue&type=style&index=0&id=61002e9a&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61002e9a"]])

export default __exports__